import { WinnerBall } from 'constants/common';
import { INotificationResponse } from 'types';

export enum ACTIONS {
  SAVE_WINNER_BALL_TO_STORE = 'SAVE_WINNER_BALL_TO_STORE',
}

export interface IWinnerBallState {
  winnerBall: WinnerBall | null;
}

type ResultBall = WinnerBall | 'UNDEFINED';

type OnSaveWinnerBallToStoreNotificationData = {
  winner: ResultBall;
};

type OnSaveConfirmedWinnerBallToStoreNotificationData = {
  winner: WinnerBall;
};

export type OnDrawFinishedData = INotificationResponse<OnSaveWinnerBallToStoreNotificationData>;

export type OnResultConfirmedData =
  INotificationResponse<OnSaveConfirmedWinnerBallToStoreNotificationData>;
